import * as React from 'react';
import { VersionTableWrapper } from './InputTableMoto.styles';

// v2 styling of the auto/autocarro version table, with the moto row shape:
// two columns (Descrizione / Data Veicolo), selection keyed on `opt.id`,
// emitting `{ id, description, prg_code_moto }` and stashing `motoDesc`.
export default function InputSelectTableMoto(props) {
  const tableRef = React.useRef();
  const selectedVehicleVersion = React.useRef(null);
  const [query, setQuery] = React.useState('');

  const normalizedQuery = query.trim().toLowerCase();
  const allOptions = props.options || [];
  const filteredOptions = normalizedQuery
    ? allOptions.filter((opt) => `${opt.description} ${opt.start_immatricolation}`
      .toLowerCase()
      .includes(normalizedQuery))
    : allOptions;

  const scrollToParent = () => {
    const parent = tableRef.current;
    const parentRect = parent.getBoundingClientRect();
    const childRect = selectedVehicleVersion.current.getBoundingClientRect();

    parent.scrollLeft += (childRect.left - parentRect.left) - (parent.clientWidth / 2);
    parent.scrollTop += (childRect.top - parentRect.top) - (parent.clientHeight / 2);
  };

  React.useEffect(() => {
    if (props.selected !== null && selectedVehicleVersion.current !== null) {
      scrollToParent();
    }
  }, [props.selected]);

  return (
    <VersionTableWrapper>
      <div className="form-input-container">
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            <label className="f-label">{props.label}</label>
            <input
              type="text"
              className="version-search"
              placeholder="Cerca versione..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
            <div className={`select-table ${props.error ? 'is-invalid' : ''} ${props.valid && !props.error ? 'is-valid' : ''}`} ref={tableRef}>
              {props.TableHeader && props.TableHeader}
              {filteredOptions.map((opt, index) => (
                <div
                  key={index}
                  ref={opt.id == props.selected ? selectedVehicleVersion : undefined}
                  onClick={() => {
                    localStorage.setItem('motoDesc', JSON.stringify(opt));
                    props.onSelectOption({
                      id: opt.id,
                      description: opt.description,
                      prg_code_moto: opt.prg_code_moto,
                    });
                  }}
                >
                  <div className={`d-none d-md-block select-table-item ${opt.id == props.selected ? 'selected' : ''}`}>
                    <div className="d-flex align-items-center">
                      <div className="col-6">{opt.description}</div>
                      <div className="col-6">{opt.start_immatricolation}</div>
                    </div>
                  </div>
                  <div className={`d-md-none border-bottom select-table-item ${opt.id == props.selected ? 'selected' : ''}`}>
                    <div className="d-flex justify-content-between align-items-center my-1">
                      <span className="px-3">Descrizione:</span>
                      <span className="px-3 text-end">{opt.description}</span>
                    </div>
                    <div className="d-flex justify-content-between align-items-baseline my-1">
                      <span className="px-3">Data Veicolo:</span>
                      <span className="px-3 text-end">{opt.start_immatricolation}</span>
                    </div>
                  </div>
                </div>
              ))}
              {allOptions.length > 0 && filteredOptions.length === 0 && (
                <div className="version-empty">
                  Nessuna versione corrisponde alla ricerca.
                </div>
              )}
              {props.children
                && (
                  <div className="children">
                    {props.children}
                  </div>
                )}
            </div>
            {props.error
              && (
                <div className="general-input-error">
                  {props.error}
                </div>
              )}
          </div>
        </div>
      </div>
    </VersionTableWrapper>
  );
}
